<template>
  <div id="orderingNotifs-page">
    <h1 class="title is-2">{{ $t('sidebar.analytics') }}</h1>
    <div class="card ">
      <div class="card-content">

        <h1 class="title is-5">{{ $t('Analytics.emailReport') }}</h1>
        <b-select :placeholder="$t('Analytics.emailReport')" v-model="place.weeklyStats">
          
          <option value="active_weekly">{{ $t('Analytics.weekly') }}</option>
          <option value="active_daily">{{ $t('Analytics.daily') }}</option>
          <option value="disabled">{{ $t('Analytics.disabled') }}</option>
         
        </b-select>

  </div>
  </div>

<div class="card">
      <div class="card-content">
        <h1 class="title is-5" >{{ $t('Analytics.yandexAnalitika') }}</h1>
          <b-input class="order-email" style="max-width:400px; margin-bottom:1rem;" type="text" v-model="place.yandexAnalitikaId" />
      </div>
</div>
<div class="card">
      <div class="card-content">
        <h1 class="title is-5" >{{ $t('Analytics.facebookPixel') }}</h1>
          <b-input class="order-email" style="max-width:400px; margin-bottom:1rem;" type="text" v-model="place.facebookPixel" />
      </div>
</div>
<div class="card">
      <div class="card-content">
        <h1 class="title is-5" >{{ $t('Analytics.googleAnalytics') }}</h1>
          <b-input class="order-email" style="max-width:400px; margin-bottom:1rem;" type="text" v-model="place.googleAnalytics" />
      </div>
</div>


  <button class="button is-success" @click="saveInfo()"
            v-bind:class="{ isLoading: isLoading }">{{ $t('DashboardTable.save') }}</button>
  </div>

</template>

<script>
        
import _ from "underscore";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SettingsAnalytics",
  components: {
   
  },
  props: [],
  computed: _.extend(
    {
    },
    mapGetters({
    place: "getPlaceInfo"
  })
  ),

  data() {
    return {
      isLoading: false,
    }
  },
  
  methods: _.extend({}, mapActions(["updatePlaceInfo"]), {
    saveInfo() {
      this.$ma.trackEvent({category: 'event', action: 'Analytics settings updated', label : null, value : null})
      this.isLoading = true
      this.updatePlaceInfo(this.place).then(() => {
        this.isLoading = false
        // this.$buefy.toast.open("Saved!")
      });
    }
    }),
  mounted() {

  }
};
</script>
